import {useAppDispatch} from "../../../context/app/AppContext";
import {useParams} from "react-router-dom";
import {useEffect} from "react";
import {updateClientAndAccountBasedOnUrl} from "../../../context/app/AppActions";
import {Container} from "reactstrap";
import {ReportsList} from "../../../components/Reports/ReportsList";

export const ReportsView = () => {
  const appDispatch = useAppDispatch()
  const routerParams = useParams();
  useEffect(() => {
    updateClientAndAccountBasedOnUrl(appDispatch, routerParams.clientId, routerParams.accountId)
  }, [])

  return (
    <>
      <Container className="mt-5">
        <ReportsList
          clientId={routerParams.clientId}
          accountId={routerParams.accountId}
        />
      </Container>
    </>
  );
}
